module.exports = __webpack_public_path__ + "fc8d41ea85cdf120b3b310ce7f709bb1.png";